import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

import 'PointOfSale/styles/components/input.less';

class POSInput extends React.Component {
  render() {
    const {
      placeholder,
      disabled,
      variant,
      focusOnMount,
      innerRef,
      ...rest
    } = this.props;

    return (
      <Input
        placeholder={placeholder}
        disabled={disabled}
        variant={variant}
        {...rest}
        ref={innerRef}
      />
    );
  }
}

POSInput.propTypes = {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['flat', 'default']),
  focusOnMount: PropTypes.bool,
};

POSInput.defaultProps = {
  placeholder: 'Dollar',
  disabled: false,
  variant: 'default',
  focusOnMount: false,
};

export default React.forwardRef((props, ref) => (
  <POSInput innerRef={ref} {...props} />
));



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/Input.js